function Countdown(container) {
  var sectionId = container.getAttribute('data-section-id'),
      counters = container.querySelectorAll('.counter-time');  
  counters.forEach(c => {
    c.classList.add('loaded');
  });
  var countdown = container.querySelector('[data-countdown]'),
      text = container.querySelectorAll('.countdown'),    
      d = countdown.querySelector('[data-days]'),
      h = countdown.querySelector('[data-hours]'),
      m = countdown.querySelector('[data-minutes]'),
      s = countdown.querySelector('[data-seconds]'),    
      date = Math.floor(countdown.getAttribute('data-date') * 1000),
      x = setInterval(function() {
        var now = new Date().getTime(),
            distance = date - now,
            days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2),
            minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2),
            seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
        if (distance < 0) {
          d.innerHTML = '<span>0</span><span>0</span>';
          h.innerHTML = '<span>0</span><span>0</span>';
          m.innerHTML = '<span>0</span><span>0</span>';
          s.innerHTML = '<span>0</span><span>0</span>';          
          clearInterval(x);
          if (text[0].classList.contains('hidden')) return;
          text.forEach(function(t){
            if (t.hasAttribute('data-before')) {
              t.classList.add('hidden');
            } else {
              t.classList.remove('hidden');
            }
          });
        } else {
          function span(n) {
            const nStr = String(n);
            const d = nStr.split('');
            const a = d.map(dgt => `<span>${dgt}</span>`);
            return a.join('');
          }
          d.innerHTML = span(days);
          h.innerHTML = span(hours);
          m.innerHTML = span(minutes);
          s.innerHTML = span(seconds);
        }
      }, 250);
}

document.addEventListener('Section:Loaded', function(myFunction){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  if(sectionType === 'countdown'){
    Countdown(sectionContainer);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  if(sectionType === 'countdown' && !sectionContainer.classList.contains('ignore')){
    Countdown(sectionContainer);
    sectionContainer.classList.add('ignore');
  }
})